import { StyledLinkButton } from '../LinkButton/LinkButton.styled'

export const Anchor = StyledLinkButton.withComponent('a')

export default Anchor
